import React, {useCallback, useState} from "react";
import {browserLocalPersistence, createUserWithEmailAndPassword, setPersistence, updateProfile} from "firebase/auth";
import {doc, setDoc} from "firebase/firestore";
import {useAuth, useFirestore} from "reactfire";
import styles from "../scss/Login.module.scss";

export const Register: React.FC = () => {
    const auth = useAuth();
    const db = useFirestore();
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [error, setError] = useState<string | null>(null);

    const formSubmitHandler = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError(null);

        if (password !== passwordConfirm) {
            setError("Passwords do not match");
            return;
        }

        if (password.length < 6) {
            setError("Password must be at least 6 characters");
            return;
        }

        try {
            await setPersistence(auth, browserLocalPersistence);
            const credentials = await createUserWithEmailAndPassword(auth, email, password);
            await updateProfile(credentials.user, {displayName: username});
            await setDoc(doc(db, `users/${credentials.user.uid}`), {assignedGroups: []});
        } catch (err) {
            console.log({err});
            setError((err as any).message);
        }
    }, [password, passwordConfirm, auth, email, username, db]);

    return (
        <div id={styles.main}>
            <main>
                <h1>Create account</h1>
                <form onSubmit={formSubmitHandler}>
                    <div
                        style={{display: "flex", flexDirection: 'row', justifyContent: 'center', marginBottom: '20px'}}>
                        <label style={{width: '100px'}} htmlFor="username">Username:</label>
                        <input
                            id="username"
                            autoComplete="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>

                    <div
                        style={{display: "flex", flexDirection: 'row', justifyContent: 'center', marginBottom: '20px'}}>
                        <label style={{width: '100px'}} htmlFor="email">Email:</label>
                        <input
                            type="email"
                            id="email"
                            autoComplete="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </div>

                    <div
                        style={{display: "flex", flexDirection: 'row', justifyContent: 'center', marginBottom: '20px'}}>
                        <label style={{width: '100px'}} htmlFor="password">Password:</label>
                        <input
                            type="password"
                            id="password"
                            autoComplete="new-password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                    </div>

                    <div
                        style={{display: "flex", flexDirection: 'row', justifyContent: 'center', marginBottom: '20px'}}>
                        <label style={{minWidth: '110px'}} htmlFor="confirm-password">Confirm password:</label>
                        <input
                            type="password"
                            id="confirm-password"
                            autoComplete="new-password"
                            value={passwordConfirm}
                            onChange={e => setPasswordConfirm(e.target.value)}
                        />
                    </div>

                    {error && <p style={{marginBottom: '10px'}} className="error">{error}</p>}

                    <div style={{display: "flex", flexDirection: "row", justifyContent: 'center', width: '100%'}}>
                        <button type="submit">Register</button>
                        <button style={{
                            height: '50px',
                            width: '270px',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            cursor: 'pointer'
                        }}>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
                                 style={{width: '30px', height: '30px'}}>
                                <path fill="#EA4335"
                                      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                                <path fill="#4285F4"
                                      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                                <path fill="#FBBC05"
                                      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                                <path fill="#34A853"
                                      d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                                <path fill="none" d="M0 0h48v48H0z"></path>
                            </svg>
                            <span style={{color: '#fff', marginLeft: '10px'}}>Sign in with Google</span>
                        </button>
                    </div>
                </form>
            </main>
        </div>
    );
};

export default Register;
